module.exports = __webpack_public_path__ + "static/img/product5.e0af94c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/product5.png
// module id = SU+A
// module chunks = 1